import {fnPostToSubject, fnDeleteSubjectID, fnModifyAsyncNoRedirect, fnFetchSubjectID} from './CrudContextProviderUtil';
import React from 'react';
import authAxios from '../api/axios';
export const UserDataContext = React.createContext();

export default function UserDataProvider(props) {

    const getUserById = (userID, setFunc) => {
        authAxios.get(`/api/user/${userID}`)
        .then(res => {
            setFunc(res.data);
        })
        .catch(err => console.log(err));
    }

    const getAllUsers = (setFunc) => {
        authAxios.get(`/api/user`)
        .then(res => {
            if(!res.data.errMsg) {
                res.data.content = res.data.content.filter(user => user.account_level < 3);
            }
            setFunc(res.data);
        })
        .catch(err => console.log(err));
    }
    

    /**
     * Note: This could be redefined on server to be more restrictive, this was for MVP usage specifically to push a working app.
     * @param {Identifier} userID User ID in database
     * @param {Object} data Modification Object
     * @param {Object} navigate History object for redirect
     * @param {String} redirectURL RedirectURL upon completion
     */
    const modifyUserAsync = (userID, data, redirectURL, navigate) =>{
        authAxios.put(`/api/user/${userID}`, data)
        .then(res => {
            // <Navigate to={redirectURL} />
            navigate(redirectURL);
        })
        .catch(err => console.log(err));
    }


    return (
        <UserDataContext.Provider value={ 
            {
                getUserById,
                getAllUsers,
                modifyUserAsync,
                fnDeleteSubjectID: fnDeleteSubjectID(authAxios, "user"),
                fnCreateNewUser: fnPostToSubject(authAxios, "user"),
                modifyUserPasswordAsyncNoRedirect: fnModifyAsyncNoRedirect(authAxios, "user/changepassword"),
                fetchAllWorkOrdersToday: fnFetchSubjectID(authAxios, "workorder/user/today")
            } }>
            { props.children }
        </UserDataContext.Provider>
    )
}
